import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { ForecasterLogo } from './ForecasterLogo';
import { FooterSection } from './sections';

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <div className="min-h-screen bg-obsidian-900 text-white antialiased">
            <nav className="fixed top-0 inset-x-0 z-50 bg-obsidian-900/80 backdrop-blur-xl border-b border-white/[0.06]">
                <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                    <Link to="/"><ForecasterLogo /></Link>

                    <div className="hidden md:flex items-center gap-6">
                        <Link to="/architecture" className="text-sm text-gray-400 hover:text-white transition-colors">
                            Architecture
                        </Link>
                        <Link to="/how-it-works" className="text-sm text-gray-400 hover:text-white transition-colors">
                            Intelligence
                        </Link>
                        <Link to="/runtime" className="text-sm text-gray-400 hover:text-white transition-colors">
                            Runtime
                        </Link>
                        <Link to="/economics" className="text-sm text-gray-400 hover:text-white transition-colors">
                            Economics
                        </Link>
                        <Link to="/platform" className="text-sm text-gray-400 hover:text-white transition-colors">
                            Platform
                        </Link>
                        <Link to="/factory" className="text-sm text-gray-400 hover:text-white transition-colors">
                            AI Factory
                        </Link>
                        <Link to="/sovereign" className="text-sm text-gray-400 hover:text-white transition-colors">
                            Sovereign AI
                        </Link>
                        <Link
                            to="/trial"
                            className="px-5 py-2.5 bg-volt-500 text-obsidian-900 rounded-lg text-sm font-semibold hover:bg-volt-400 transition-all hover:shadow-volt"
                        >
                            Start Free Trial
                        </Link>
                    </div>

                    <button
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        className="md:hidden p-2 rounded-lg hover:bg-white/10"
                    >
                        {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>

                {isMobileMenuOpen && (
                    <div className="md:hidden border-t border-white/[0.06] bg-obsidian-900 px-6 py-4 space-y-3">
                        <Link to="/architecture" className="block py-2 text-gray-400 hover:text-white">Architecture</Link>
                        <Link to="/how-it-works" className="block py-2 text-gray-400 hover:text-white">Intelligence</Link>
                        <Link to="/runtime" className="block py-2 text-gray-400 hover:text-white">Runtime</Link>
                        <Link to="/economics" className="block py-2 text-gray-400 hover:text-white">Economics</Link>
                        <Link to="/platform" className="block py-2 text-gray-400 hover:text-white">Platform</Link>
                        <Link to="/factory" className="block py-2 text-gray-400 hover:text-white">AI Factory</Link>
                        <Link to="/sovereign" className="block py-2 text-gray-400 hover:text-white">Sovereign AI</Link>
                        <Link
                            to="/trial"
                            className="block px-4 py-2.5 bg-volt-500 text-obsidian-900 rounded-lg text-sm font-semibold text-center"
                        >
                            Start Free Trial
                        </Link>
                    </div>
                )}
            </nav>

            <div className="pt-16">
                {children}
            </div>

            <FooterSection />
        </div>
    );
};
